import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ConsoleVpsComponent from "../../../components/Customer/vps/ConsoleVpsComponent";

const ConsoleVpsPage = () => {
    const params = useParams();
    const navigate = useNavigate();

    let redirectBack = () => {
        navigate(-1);
    }

    return <ConsoleVpsComponent
        vpsId={ params.vpsId }
        redirectBack={ () => redirectBack() }
    />

}

export default ConsoleVpsPage;